import {memo} from "react";
import {makeStyles} from "tss-react/mui";

const spacing = "0.4em";

const useStyles = makeStyles()({
    root: {
        fontSize: "0.85em",
        display: "flex",
        alignItems: "center",
        "&:not(:last-child)": {
            marginRight: spacing,
            "&:after": {
                paddingLeft: spacing,
                content: '"/"',
                opacity: 0.7,
            },
        },
    },
});

const Breadcrumb = memo((props: {children: React.ReactNode}) => {
    const {classes} = useStyles();
    return <span className={classes.root}>{props.children}</span>;
});

export default Breadcrumb;
